// @mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//
import { usePortal } from 'src/hooks/use-portal';
import { Stack } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';
import CategoryList from '../category-list';

// ----------------------------------------------------------------------

export default function CategoryListHomeView({ isRTL }: any) {
  const { categories, loading } = usePortal({});
  const mdUp = useResponsive('up', 'md');

  return (
    <Container>
      <Stack spacing={5} sx={{ textAlign: 'center', my: 5 }}>
        <Typography variant="h2">{isRTL ? 'الفئات' : 'Categories'}</Typography>
        <Typography sx={{ fontSize: mdUp ? 24 : 16, width: '80%', textAlign: 'left' }}>
          {isRTL
            ? 'استكشف الفئات الرئيسية لدينا واحصل على أفضل العروض والخصومات'
            : 'Explore our top categories and get the best offers and discounts'}
        </Typography>
      </Stack>
      <CategoryList categories={categories} loading={loading} />
    </Container>
  );
}
